const getPropertyCardData = (propertyDetail) => {
  if (process.env.GATSBY_COUNTRY === 'MX') {
    return {
      property: {
        title: propertyDetail.property.title,
        description: propertyDetail.property.description,
        images: propertyDetail.property.images,
        url360: propertyDetail.property.url_360,
        propertyDetail: {
          roomNum: propertyDetail.property.property_detail.room_num,
          bath: propertyDetail.property.property_detail.bath,
          yearsOld: propertyDetail.property.property_detail.years_old,
          phone: propertyDetail.property.property_detail.phone,
          metropolitanZone:
            propertyDetail.property.property_detail.metropolitan_zone,
          address: propertyDetail.property.property_detail.address,
          latitude: propertyDetail.property.property_detail.latitude,
          longitude: propertyDetail.property.property_detail.longitude,
          buildSet: propertyDetail.property.property_detail.building_set,
          medianZone: propertyDetail.property.property_detail.median_zone,
          cityName: propertyDetail.property.property_detail.city_name,
          suburb: propertyDetail.property.property_detail.suburb,
          area: propertyDetail.property.property_detail.area,
          flat: propertyDetail.property.property_detail.flat,
          elevatorNum: propertyDetail.property.property_detail.elevator_num,
          garage: propertyDetail.property.property_detail.garage,
          price: propertyDetail.property.property_detail.price,
          priceOld: propertyDetail.property.property_detail.price_old,
          propertyType: propertyDetail.property.property_detail.property_type,
          zipCode: propertyDetail.property.property_detail.zip_code,
          propertyMomentId:
            propertyDetail.property.property_detail.property_moment_id,
          inventoryTypeId:
            propertyDetail.property.property_detail.inventory_type_id,
          was_renovated: propertyDetail.property.property_detail.was_renovated,
          hasThreeChecks: propertyDetail.property.property_detail.has_three_checks,
          isFranchise: propertyDetail.property.property_detail.is_franchise,
        },
      },
      saleFlag: false,
      services: [],
      interestPlace: propertyDetail.interest_place,
      iconDetails: propertyDetail.icon_details,
    };
  }

  return {
    property: {
      title: propertyDetail.property.titulo,
      description: propertyDetail.property.descripcion,
      images: propertyDetail.property.images,
      url360: propertyDetail.property.url_360,
      propertyDetail: {
        roomNum: propertyDetail.property.detalles_propiedad.num_habitaciones,
        bath: propertyDetail.property.detalles_propiedad.banos,
        yearsOld: propertyDetail.property.detalles_propiedad.anos_antiguedad,
        phone: propertyDetail.property.detalles_propiedad.telefono,
        zoneContact: propertyDetail.property.detalles_propiedad.contacto_zona,
        published: propertyDetail.property.detalles_propiedad.publicado,
        metropolitanZone:
          propertyDetail.property.detalles_propiedad.zona_metropolitana,
        address: propertyDetail.property.detalles_propiedad.direccion,
        latitude: propertyDetail.property.detalles_propiedad.latitud,
        longitude: propertyDetail.property.detalles_propiedad.longitud,
        buildSet: propertyDetail.property.detalles_propiedad.conjunto,
        medianZone: propertyDetail.property.detalles_propiedad.zona_mediana,
        cityName: propertyDetail.property.detalles_propiedad.ciudad,
        area: propertyDetail.property.detalles_propiedad.area,
        flat: propertyDetail.property.detalles_propiedad.num_piso,
        elevatorNum: propertyDetail.property.detalles_propiedad.num_ascensores,
        garage: propertyDetail.property.detalles_propiedad.garages,
        price: propertyDetail.property.detalles_propiedad.precio_venta,
        priceOld: propertyDetail.property.detalles_propiedad.precio_anterior,
        propertyType: propertyDetail.property.detalles_propiedad.tipo_inmueble,
        propertyMomentId:
          propertyDetail.property.detalles_propiedad.property_moment_id,
        inventoryTypeId:
          propertyDetail.property.detalles_propiedad.inventory_type_id,
      },
    },
    saleFlag: propertyDetail.old_inventory_flag,
    services: propertyDetail.servicios,
    interestPlace: propertyDetail.sitios_interes,
    iconDetails: propertyDetail.icon_details,
  };
};

export default getPropertyCardData;
